module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "hgroup"
  }, [_c('h3'), _vm._v(" "), _c('h1', [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1em",
      "line-height": "1.5",
      "text-indent": "1.5em"
    }
  }, [_vm._v("Under the pier it was pitch-dark. The boy clinging to the barnacle-crusted beam could hear only his own heavy gasps as he fought to slow his breathing. He could feel only the thud of his heart that seemed to shake his whole body.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("\n\tA wave splashed high and drenched him.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("\n\tHe crept a few feet along the beam. His knee slipped on the wet, dragging weed, and he reached frantically for a better grip. A sharp pain sliced along his palm. For an instant he balanced dangerously over the unseen, sucking water.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("\n\tThen he found his balance and froze motionless. The planks above him were shaking with sudden, heavy footsteps.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("\n\tA deep voice said, “He isn’t out here.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("\n\t“I think he went up Cabrillo Street,” a younger voice agreed. The footsteps stopped almost above the boy’s head.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("\n\t“Why the hell didn’t you shoot?” the deep voice asked angrily.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("\n\t“Well, look, Sergeant.” The younger voice sounded defensive. “I thought we had orders to keep things quiet. The Chief said anything can start trouble when these kids are in town.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("\n\tThe heavy voice said, “You’ve got a lot to learn. This Udall kid’s a killer. Don’t ever take chances with a boy like that. You’re lucky you’re still alive.” His voice roared out suddenly. “Peterson! Anything over there?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("\n\tA distant shout answered him. Under the pier the boy shuddered as another wave splashed icy spray over him.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("\n\t“Come on,” the sergeant said, and the footsteps began to recede. “Next time, use your gun. You don’t have to put a bullet in him. Just fire in the air. But scare him so he’ll stop running. They don’t send out an A.P.B. unless they mean…”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("\n\tThe voices faded. The planks overhead stopped vibrating. The footsteps were gone.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("\n\tThe boy lifted his head, wiped the salt from his eyes, and looked ahead over the Pacific Ocean. The spars of boats swung back and forth, rocking with the waves. Inland, the lights of Newport Beach fought with the moonlight. It was noisy. Music and voices, an outburst of distant shouting.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("\n\tThe Easter holiday was just beginning, and two thousand teen-agers had invaded the California coast from Newport Beach to San Diego.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("\n\tThe boy had no destination. He was on the run, and something had caught him up in the young tide that was flowing from Los Angeles toward Newport. But that had been a mistake. The police were in Newport, too, ready for trouble.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("\n\tThe boy shivered in his wet clothes, hugging the beam.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("\n\tThen, carefully, he reached into his pocket and brought out the ring. He moved his hand gently forward into the moonlight, cupping the bright thing in his palm.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("\n\tThe sapphire was blue as peace.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("\n\tHis fingers began to tremble. He was trying not to think at all. He was trying to forget everything but the blue sapphire and the way it could make everything all right again, somehow, if only…")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("\n\tHe closed his hand tight over it as his fingers began to tremble uncontrollably. When the trembling had passed and he opened his hand, the ring lay in a smear of blood that looked dark in the moonlight.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("\n\tHe thought how red blood really is.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("\n\tHe heard himself gasp and catch his breath, and then cry out thinly. He shut his eyes tight, but he couldn’t stop the memory from coming back.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("\n\tNow he was back in San Francisco three nights ago. Now he was fitting the key into the door, hearing the lock click over, walking across the threshold. He saw the blue rug, the green dress, the white throat, and the white face turned toward him. He saw her eyes open, watching him.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("\n\tBut white skin, green dress, blue eyes, were all motionless there at his feet on the blue rug, and the only moving things were three winding crimson snakes that moved, sluggish and bright, down Ann Avery’s side.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("\n\tShe was dead. He could never forget how red blood really is, or how sharp it smells, acrid as the smell from the salty, hissing water under the beam he gripped.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("\n\tAbove him the planks shook suddenly.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("\n\t“…heard it, too,” the heavy voice said.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("\n\t“It came from out here.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("\n\tA flashlight killed the moonlight, flooding his face.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("\n\t“There he is!”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("\n\tCold and final, a voice said, “Don’t move, boy. Don’t you move an inch.”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("\n\tAnother voice said with excitement in it, “That’s Udall, all right. That’s the kid they want for Ann Avery’s murder.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b5c9b3ac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/05_chapter01.vue
// module id = 66
// module chunks = 0